export const initialChockingFormData = {
  care_plan: "",
  q_coughs: false,
  q_coughs_comments: "",
  q_is_diagnosed: false,
  q_is_diagnosed_comments: "",
  q_choking_hist: false,
  q_choking_hist_comments: "",
  q_chest_infection_hist: false,
  q_chest_infection_hist_comments: "",
  q_has_change: false,
  q_change_options: [],
  q_change_comments: "",
  q_can_chew: true,
  q_can_chew_comments: "",
  q_is_diet_modified: false,
  q_is_diet_modified_comments: "",
  q_has_pica: false,
  q_has_pica_comments: "",
  q_has_risk_behaviours: false,
  q_has_risk_behaviours_comments: "",
  q_has_side_effects: false,
  q_side_effect_options: [],
  q_side_effect_comments: "",
  summary: "",
};

export const SIGNIFICANT_CHANGE_OPTIONS = [
  { value: "Unplanned weight loss", label: "Unplanned weight loss" },
  { value: "Fluid Intake", label: "Fluid Intake" },
  {
    value: "Time taken to complete meal/drink",
    label: "Time taken to complete meal/drink",
  },
  { value: "Self-feeding skills", label: "Self-feeding skills" },
  { value: "Environment", label: "Environment" },
  { value: "General health", label: "General health" },
];

export const MEDICATION_SIDE_EFFECT_OPTIONS = [
  { value: "Relaxed muscle tone", label: "Relaxed muscle tone" },
  { value: "Drowsiness", label: "Drowsiness" },
  { value: "Dryness of the mouth", label: "Dryness of the mouth" },
  { value: "Increased saliva", label: "Increased saliva" },
];
